import { render, staticRenderFns } from "./PriceLevel.vue?vue&type=template&id=4f8c4c90&scoped=true"
import script from "./PriceLevel.vue?vue&type=script&lang=js"
export * from "./PriceLevel.vue?vue&type=script&lang=js"
import style0 from "./PriceLevel.vue?vue&type=style&index=0&id=4f8c4c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c4c90",
  null
  
)

export default component.exports